var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.29492,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#005083"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3944_2195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4797 21.2891C15.4081 22.5582 15.6357 23.8433 16.1613 25.0282L11.4778 27.419C10.4471 25.5633 9.86287 23.4347 9.79492 21.2891H15.4797Z",
    fill: "#005083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7795 26.1719C17.4901 27.2711 18.4756 28.2151 19.6352 28.886L17.5022 33.0627C15.6193 32.1823 13.9394 30.8457 12.6426 29.1821L16.7795 26.1719Z",
    fill: "#005083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8467 29.4688C21.482 29.7123 22.1439 29.8796 22.8187 29.9671C23.5039 30.0563 24.1972 30.0651 24.8844 29.9934L25.5235 34.065C24.5219 34.2576 23.5013 34.3327 22.4824 34.2886C21.4527 34.2444 20.432 34.0784 19.4414 33.7939L20.8467 29.4688Z",
    fill: "#005083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 29.7412C27.5962 29.3803 28.8726 28.6862 29.9339 27.7243L32.4457 30.2372C31.0938 31.6911 29.3816 32.8353 27.4783 33.5263L26.25 29.7412ZM30.9197 26.6806C31.8259 25.5585 32.4697 24.2092 32.7678 22.7656L35.716 23.2297C35.4861 25.1603 34.7834 27.0516 33.6771 28.6883L30.9197 26.6806Z",
    fill: "#005083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9529 21.296C33.0255 19.8078 32.7447 18.2945 32.1172 16.9103L34.2693 15.8125C35.1972 17.4695 35.7271 19.3699 35.7953 21.2967L32.9529 21.296Z",
    fill: "#005083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.381 15.5709C30.54 14.2917 29.3825 13.1996 28.0234 12.4264L28.8642 10.7812C30.5472 11.5602 32.0545 12.7497 33.22 14.2335L31.381 15.5709Z",
    fill: "#005083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.606 11.7641C25.1341 11.2091 23.5078 11.0072 21.9089 11.1857L21.7109 9.92208C23.4856 9.57235 25.3576 9.63861 27.1335 10.1423L26.606 11.7641Z",
    fill: "#005083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3271 11.4877C18.7663 11.9177 17.2947 12.7318 16.0764 13.8502L15.5742 13.3474C16.7699 12.0505 18.2875 11.0273 19.9764 10.4062L20.3271 11.4877Z",
    fill: "#005083"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3944_2195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(9.79492 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepCurrent);
export default __webpack_public_path__ + "static/media/step-current.71fe59d470a2c350c298e18a862ee301.svg";
export { ForwardRef as ReactComponent };